// =====================================================================
// Chamados — como cada STATUS do banco é lido por um humano.
//
// ⚠️⚠️ NASCEU DA TERCEIRA CÓPIA (03/09/2026). Este mapa estava escrito
// igual na `ChamadosConsulta` (a fila) e na `ChamadosAtivos` (a ficha do
// equipamento), e a pop-up do calendário ia ser a terceira. Duas cópias já
// haviam sobrevivido à entrada do `Finalizado` e do `Validado` por sorte —
// alguém lembrou das duas no mesmo dia. Na terceira não se lembra, e o efeito
// é a tela mostrando o valor CRU do banco ('Atribuido' sem acento, ou o status
// novo sem tradução) sem erro nenhum.
//
// ⚠️ É VOCABULÁRIO DE TELA, não regra: a régua de "o trabalho acabou?" mora no
// `chamados-fila-utils.js` (espelho do `chamados-fluxo.js` do servidor). Este
// arquivo não decide nada, só nomeia — e por isso não precisa de teste de
// espelho.
// =====================================================================

/**
 * O rótulo de cada status.
 *
 * ⚠️ Uso: `ROTULO_STATUS[c.STATUS] || c.STATUS`. O fallback é o valor cru de
 * propósito — status novo no `ENUM` aparece feio, o que é infinitamente melhor
 * do que aparecer vazio e a pessoa achar que o chamado não tem situação.
 *
 * ⚠️ Dois rótulos DIZEM QUE NÃO ACABOU, e é a razão de o mapa existir:
 *   • `Atendimento Pausado` → "Atendimento pausado". O estado se chamava
 *     `Aguardando loja` até 17/09/2026: o nome descrevia UM dos motivos de
 *     parada (a loja) e mentia nos outros — falta de acesso, movimento na loja,
 *     espera curta. Desde então o técnico DIZ o motivo, e ele é obrigatório.
 *   • `Finalizado` → "Atendimento finalizado". "Finalizado" sozinho é a palavra
 *     mais perigosa do módulo: a loja lê e entende que o chamado terminou. O que
 *     terminou é o que estava na mão do técnico — a espera agora é de terceiro
 *     (o Invgate, uma peça, um reparo).
 *   • `Encerrado` → "Aguardando validação". Desde 31/08/2026 ele não é mais o
 *     fim: falta a ciência da loja, e é o `Validado` que fecha o chamado.
 */
export const ROTULO_STATUS = {
    'Aberto': 'Aguardando triagem',
    'Atribuido': 'Atribuído',
    'Em atendimento': 'Em atendimento',
    'Atendimento Pausado': 'Atendimento pausado',
    // ⚠️ LEGADO: era o nome da PAUSA no banco até 17/09/2026, quando o valor foi
    //    renomeado por migration. Nada mais o escreve, e o rótulo fica aqui para
    //    um chamado antigo — ou uma linha que a migration não tenha alcançado —
    //    não aparecer na tela com o valor cru.
    'Aguardando loja': 'Atendimento pausado',
    'Finalizado': 'Atendimento finalizado',
    // ⚠️ LEGADO: nada mais escreve 'Concluido'. O rótulo diz isso para quem
    //    encontrar uma linha antiga e for procurar o botão que a produziu.
    'Concluido': 'Concluído (legado)',
    'Encerrado': 'Aguardando validação',
    'Validado': 'Validado',
    'Cancelado': 'Cancelado',
};

/** O rótulo do status, com o valor cru como último recurso. */
export function rotuloStatus(status) {
    return ROTULO_STATUS[status] || status || '—';
}
